/** AppShell — persistent layout for authenticated pages. Top bar + content area. */

import { Outlet, Link, useNavigate } from "react-router-dom";
import { signOut } from "@/firebase";
import { useAuthStore } from "@/stores/auth";

export function AppShell() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  const isPro = user?.plan === "pro";

  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/dashboard" className="topbar-brand">
          RALEY
        </Link>
        <nav className="topbar-nav">
          <Link to="/dashboard" className="topbar-link">
            Competitions
          </Link>
          <Link to="/riders" className="topbar-link">
            Riders
          </Link>
          <Link to="/training" className="topbar-link">
            Training
          </Link>
        </nav>
        <div className="topbar-user">
          {isPro ? (
            <span
              className="badge"
              style={{
                background: "linear-gradient(135deg, #f59e0b, #d97706)",
                color: "#fff",
                fontSize: 10,
                fontWeight: 700,
                padding: "2px 8px",
                letterSpacing: 0.5,
                cursor: "pointer",
              }}
              onClick={() => navigate("/upgrade")}
            >
              PRO
            </span>
          ) : (
            <button
              onClick={() => navigate("/upgrade")}
              className="btn btn-sm"
              style={{
                background: "linear-gradient(135deg, #f59e0b, #d97706)",
                color: "#fff",
                border: "none",
                fontSize: 11,
                fontWeight: 600,
                padding: "3px 10px",
              }}
            >
              Upgrade
            </button>
          )}
          <span className="topbar-email">{user?.display_name ?? user?.email}</span>
          <button onClick={handleSignOut} className="btn btn-ghost btn-sm">
            Sign out
          </button>
        </div>
      </header>
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
